export default
{
  pic: ['Foto', 'Photo', 'Foto'],
  of: ['de', 'of', 'de'],
  empty: ['Sua Lista de Compras está vazia!', 'Your Shopping list is empty', 'Su lista de compras está vacía'],
  upperPart: ['Parte superior', 'Upper part'],
  lowerPart: ['Parte inferior', 'Lower part'],
  accessories: ['Acessórios', 'Accessories'],
  shoes: ['Sapatos', 'Shoes'],
  makeup: ['Maquiagens', 'Makeups'],
  other: ['Outros', 'Other'],
  bought: ['Comprado', 'Bought', 'Comprado'],
  notBought: ['Não comprado', 'Not Bought', 'No Comprado']
}



// WEBPACK FOOTER //
// ./src/constants/ListCompras.js